import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const RemoveModal = ({ closeModal, msg, translate, onSubmit, data }) => (
  <section className='help-config-removeModal'>
    <h3>
      <strong>{translate('label.help.config.remove.help')}</strong>
    </h3>

    <p>{translate(`label.help.config.remove.question`)} </p>

    <label>{`${translate('option.item')}: ${msg || ''}`}</label>

    <Row className='flex margin-top-quadruple'>
      <Col xsOffset={2} xs={4}>
        <button className='button button-full' onClick={closeModal}>
          {translate('button.cancel')}
        </button>
      </Col>
      <Col xs={4}>
        <button
          className='button button-danger button-full'
          onClick={() => onSubmit({ idHelpConfig: data.idHelpConfig })}
        >
          {translate('button.yes.remove')}
        </button>
      </Col>
    </Row>
  </section>
)

RemoveModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  msg: PropTypes.any.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default RemoveModal
